import { IonIcon } from '@ionic/react';
import { caretBackOutline, reloadOutline, settingsOutline } from 'ionicons/icons';
import React, { MouseEvent } from 'react';
import useMapUtils from './useMapUtils';
import Input from '../UI/Input';

interface MapElementShaperProps {
    onRotateStart?: (e: MouseEvent<Element>) => void
    onResizeStart?: (e: MouseEvent<Element>) => void
    onLayerChange?: (dmLayer: boolean) => void
    onUiToggle?: () => void,
    dmLayer?: boolean,
    rotation?: number
}

const MapElementShaper = ({
    onRotateStart, onResizeStart, onLayerChange, onUiToggle, dmLayer, rotation,
}: MapElementShaperProps) => {

    const { normalizedScale } = useMapUtils();
    return (
        <>
            <div
                className={`absolute w-full h-full left-0 top-0 z-10`}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    style={{
                        scale: `${normalizedScale} 1`,
                        transform: 'translateX(-2px)',
                    }}
                    className='absolute h-full w-[2px] bg-emerald-500 top-0 left-0'
                />
                <div
                    style={{
                        scale: `${normalizedScale} 1`,
                        transform: 'translateX(2px)',
                    }}
                    className='absolute h-full w-[2px] bg-emerald-500 tp[-0 right-0'
                />
                <div
                    style={{
                        scale: `1 ${normalizedScale}`,
                        transform: 'translateY(-2px)',
                    }}
                    className='absolute w-full h-[2px] bg-emerald-500 top-0 left-0'
                />
                <div
                    style={{
                        scale: `1 ${normalizedScale}`,
                        transform: 'translateY(2px)',
                    }}
                    className='absolute w-full h-[2px] bg-emerald-500 bottom-0 left-0'
                />
            </div>
            <div
                className={`absolute w-full h-full left-0 top-0 z-10`}
                onClick={(e) => e.stopPropagation()}
            >
                {onRotateStart && (
                    <IonIcon
                        onDragStart={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onRotateStart(e as MouseEvent<Element>);
                        }}
                        draggable
                        style={{ transform: `translateX(50%) translateY(-50%) scale(${normalizedScale})`}}
                        size="large"
                        className='absolute top-0 right-0 text-emerald-500 fill-emerald-500 '
                        icon={reloadOutline}
                    />
                )}
                {onResizeStart && (
                    <IonIcon
                        onDragStart={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onResizeStart(e);
                        }}
                        draggable
                        style={{ transform: `translateX(50%) translateY(50%) scale(${normalizedScale}) rotate(225deg)`}}
                        size="large"
                        className='absolute bottom-0 right-0 text-emerald-500 fill-emerald-500'
                        icon={caretBackOutline}
                    />
                )}
                <div
                    className='absolute w-full h-full left-0 top-0 z-10'
                    style={{
                        rotate: `${-(rotation ?? 0)}deg`,
                    }}
                    onClick={(e) => e.stopPropagation()}
                >
                    {onLayerChange && (
                        <div
                            style={{
                                scale: `${normalizedScale}`,
                            }}
                            className={'absolute -bottom-12 -right-12 flex items-center'
                            + ' bg-mid-blue p-2 rounded-xl'}
                        >
                            <span className="ml-3 text-sm font-medium text-white me-2">Public</span>
                            <label className="relative inline-flex items-center justify-center cursor-pointer">
                                <Input
                                    type="checkbox"
                                    onChange={() => onLayerChange(!dmLayer)}
                                    checked={dmLayer}
                                    value=""
                                    className="sr-only peer"
                                />
                                <div
                                    className={"w-11 h-6 bg-gray-200 "
                                    + " rounded-xl"
                                    + " bg-gray-400 peer-checked:after:translate-x-full"
                                    + " peer-checked:after:border-white after:content-[''] after:absolute"
                                    + " after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300"
                                    + " after:border after:rounded-xl after:h-5 after:w-5 after:transition-all"
                                    + " border-gray-600 peer-checked:bg-blue-600"}
                                />
                                <span className="ml-3 text-sm font-medium">DM</span>
                            </label>
                        </div>
                    )}
                    {onUiToggle && (
                        <div
                            style={{
                                scale: `${normalizedScale}`,
                            }}
                            className={'absolute -top-6 -left-6 flex items-center justify-center'
                            + ' bg-mid-blue text-slate-0 rounded-xl w-8 h-8 p-1'}
                            onClick={onUiToggle}
                        >
                            <IonIcon size='large' color="white" icon={settingsOutline} />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default MapElementShaper;
